import apiClient from './client';
import { Trip, TripFilters, TripListResponse } from '../types/trip';

export const tripsApi = {
  getTrips: async (filters?: TripFilters): Promise<TripListResponse> => {
    const params = new URLSearchParams();

    if (filters?.startDate) params.append('startDate', filters.startDate);
    if (filters?.endDate) params.append('endDate', filters.endDate);
    if (filters?.driverId) params.append('driverId', filters.driverId);
    if (filters?.vehicleId) params.append('vehicle_id', filters.vehicleId);
    if (filters?.qualification) params.append('status', filters.qualification);
    if (filters?.page) params.append('page', filters.page.toString());
    if (filters?.limit) params.append('limit', filters.limit.toString());

    const response = await apiClient.get<TripListResponse>(`/api/trips?${params.toString()}`);
    return response.data;
  },

  getTripById: async (id: string): Promise<{ success: boolean; data: Trip }> => {
    const response = await apiClient.get(`/api/trips/${id}`);
    return response.data;
  },

  getPendingTrips: async (
    daysOld?: number
  ): Promise<{ success: boolean; data: Trip[] }> => {
    const params = daysOld ? `?daysOld=${daysOld}` : '';
    const response = await apiClient.get(`/api/trips/pending${params}`);
    return response.data;
  },

  qualifyTrip: async (
    id: string,
    qualification: 'professional' | 'personal',
    note?: string
  ): Promise<{ success: boolean; data: Trip }> => {
    const response = await apiClient.post(`/api/trips/${id}/qualify`, {
      qualification,
      note,
    });
    return response.data;
  },

  updateTrip: async (
    id: string,
    data: Partial<Trip>
  ): Promise<{ success: boolean; data: Trip }> => {
    const response = await apiClient.patch(`/api/trips/${id}`, data);
    return response.data;
  },

  deleteTrip: async (id: string): Promise<{ success: boolean; message: string }> => {
    const response = await apiClient.delete(`/api/trips/${id}`);
    return response.data;
  },

  generateDemoTrips: async (payload: {
    count: number;
    company_id?: string;
    driver_id?: string;
  }): Promise<{ success: boolean; data: { created: number; trips: Trip[] } }> => {
    const response = await apiClient.post('/api/trips/demo', payload);
    return response.data;
  },

  getTripPoints: async (
    tripId: string
  ): Promise<{ lat: number; lon: number; timestamp: string; speed: number }[]> => {
    const response = await apiClient.get(`/api/trips/${tripId}/points`);
    return response.data?.data?.points || [];
  },
};
